import React, { useState, useEffect, createContext, useContext, useRef } from "react";
import { useQuery, useLazyQuery } from "@apollo/client";

import { GET_PROGRAMS } from "../schemas/program";
import { GET_USER } from "../schemas/profile";
import { GET_FAVORITES } from "../schemas/favorite";

// Create Context Object
const GlobalStateContext = createContext();

// allow inset widgets outside of react component;
let AddWidget;
export { AddWidget };

// Create a provider for components to consume and subscribe to changes
export const GlobalStateProvider = (props) => {
  const [globalState, setGlobalState] = useState(props.store);
  const [components, setComponents] = useState([]);
  const [foundLoginButton, setFoundLoginButton] = useState(false);
  const [foundRegistrationButton, setFoundRegistrationButton] = useState(false);
  const loginButton = useRef(null);
  const registrationButton = useRef(null);
  const registrationButtonUrl = useRef(null);
  let loginPopUpButton="";
  
  const [getFavorites, {  data: favoriteData, loading: favoriteLoading }] = useLazyQuery(GET_FAVORITES, {
    fetchPolicy: "no-cache",
  });

  //search
  const [getPrograms, { loading, data, error }] = useLazyQuery(GET_PROGRAMS, {
    fetchPolicy: "no-cache",
  });
  //user
  const { loading: userLoading, data: userData } = useQuery(GET_USER, {
    fetchPolicy: "no-cache",
  });
  
  const findLoginElement = () => {
    if(!foundLoginButton) {
      if(!Utils.isMobile()){
       loginPopUpButton = document.querySelector("#wrap-personal-button-desc");
      } else {
        loginPopUpButton = document.querySelector("#wrap-personal-button-mob");
        }
      if (loginPopUpButton ) {
        loginButton.current = loginPopUpButton;
        setFoundLoginButton(true);
        } 
     
    }
  }
  const findRegistrationElement = () => {
    if(!foundRegistrationButton) {
      const wraperLink = document.querySelector('.register-link-wrapper');
      if (wraperLink) {
        const RegistrationPopUpButton = wraperLink.querySelector(".register");
        const RegistrationUrl = RegistrationPopUpButton.href;
        if ( RegistrationPopUpButton ) {
          registrationButton.current = RegistrationPopUpButton;
          registrationButtonUrl.current = RegistrationUrl;
          setFoundRegistrationButton(true);
        }
      }
    }
  }

  const changeLoginPopUpToRedirectToProfile = () => {
    loginButton.current.removeAttribute("data-toggle");
    loginButton.current.removeAttribute("data-target");
    loginButton.current.setAttribute("href", "/he/profile");
  } 

  const changeRegistrationBtnUrl = () => {
    let urlTrackId = "?";
    favoriteData.getFavorites.body.forEach(function(program, index) {
      if (program.trackId && index <= 20) {
        if (index == favoriteData.getFavorites.body.length-1 ) {
          urlTrackId += program.trackId;
        } else {
          urlTrackId += program.trackId + '_';
        }
      }
    })
    registrationButton.current.setAttribute("href",urlTrackId==='?' ?registrationButtonUrl.current : registrationButtonUrl.current + urlTrackId);
  } 

  //search for the login button until it is loaded
  useEffect(() => {
    let searchElement = setInterval(findLoginElement, 250);
    return function cleanup() {
        clearInterval(searchElement);
    }
  })

  //search for the registration link until it is loaded
  useEffect(() => {
    let searchRegistrationButton = setInterval(findRegistrationElement, 250);
    return function cleanup() {
        clearInterval(searchRegistrationButton);
    }
  })
  useEffect(() => {
    if (foundLoginButton && userData?.user) {
      changeLoginPopUpToRedirectToProfile()
    }
  },[foundLoginButton])

  useEffect(() => {
    if (foundRegistrationButton && !favoriteLoading && favoriteData) {
      changeRegistrationBtnUrl();
    }
  },[foundRegistrationButton])

  useEffect(() => {
    setGlobalState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        query: getPrograms,
      },
    }));
  }, []);

  useEffect(() => {
    if (!loading && data) {
      setGlobalState((prevState) => ({
        ...prevState,
        search: { 
          ...prevState.search, 
          query: getPrograms,
          results: data.getPrograms?.results ?? "", 
          loading: loading
        },
      }));

    }
    if (error) {
      console.log(error);
    }
  }, [loading ,data, error]);
  //

  //user
  useEffect(() => {
    setGlobalState((prevState) => ({
      ...prevState,
      user: { ...userData, loading: userLoading },
    }));
    if (!userLoading && userData) {
      getFavorites();
    }
  }, [userLoading, userData]);
  //

  AddWidget = (widget) => setComponents([...components, widget]);

  return (
    <GlobalStateContext.Provider value={[globalState, setGlobalState]}>
      {props.children || components}
    </GlobalStateContext.Provider>
  );
};

// Get State Data
export const GlobalState = (type) => {
  const [globalState, setGlobalState] = useContext(GlobalStateContext);
  
  return [
    globalState[type],
    (data) => setGlobalState({ ...globalState, [type]: data }),
  ];
};

// Get GlobalState as default
export default GlobalState;

